import { useApolloClient } from '@apollo/client';
import { Order_By } from '@openx/types/gqlTypes.ts';
import { useQuery } from '@tanstack/react-query';
import {
  GetOrganizationsListDocument,
  type GetOrganizationsListQuery,
  type GetOrganizationsListQueryVariables,
} from '../../../graphql/query/organizations/GetOrganizationsList.generated.tsx';
import { mapOrganizationsToId } from '../../../modules/audiences/AudienceForm/utils/mapOrganizationsToId.ts';

const organizationsListQueryKey = ['organizationsList'] as const;

export const useDealPromptOrganizationsList = () => {
  const client = useApolloClient();

  const { data, isLoading } = useQuery({
    queryKey: [...organizationsListQueryKey, { order_by: [{ name: Order_By.Asc }] }],
    queryFn: async () => {
      const result = await client.query<GetOrganizationsListQuery, GetOrganizationsListQueryVariables>({
        query: GetOrganizationsListDocument,
        variables: {
          order_by: [{ name: Order_By.Asc }],
        },
      });
      return result.data;
    },
  });

  const organizations = data?.account ?? [];
  const organizationsById = mapOrganizationsToId(organizations);

  return {
    organizationsById,
    loading: isLoading,
  };
};
